import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/auth/landing" />;
    }

    return <>{children}</>;
}
